import React from 'react';

export const ModernTable = ({
  columns = [],
  data = [],
  keyExtractor = (item, index) => item?._id || index,
  isLoading = false,
  emptyMessage = "No data available",
  onRowClick,
}) => {
  if (isLoading) {
    return (
      <div className="w-full flex items-center justify-center p-12 bg-white rounded-2xl shadow-[0_2px_10px_rgba(0,0,0,0.02)] border border-gray-100">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-black"></div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="w-full flex flex-col items-center justify-center p-20 bg-white rounded-2xl shadow-[0_2px_10px_rgba(0,0,0,0.02)] border border-gray-100 text-gray-400">
        <span className="text-[12px] font-semibold tracking-widest uppercase mb-2">No Data Available</span>
        <span className="text-[13px] font-medium text-gray-400">{emptyMessage}</span>
      </div>
    );
  }

  return (
    <div className="w-full bg-white border border-[#ECE7DE] overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead className="bg-[#C91D25] border-b border-[#A27327]">
            <tr className="bg-[#C91D25] divide-x divide-white/20">
              {columns.map((col, idx) => (
                <th
                  key={`th-${idx}`}
                  className={`px-3 py-2 text-[12px] font-medium text-white tracking-tight border-r border-white/20 last:border-r-0 font-sans whitespace-nowrap ${col.className || ''}`}
                  style={{ minWidth: col.minWidth, width: col.width }}
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200/80 bg-white font-sans">
            {data.map((row, rowIdx) => {
              const isInactive = row?.isDisabled || false;
              
              return (
                <tr
                  key={keyExtractor(row, rowIdx)}
                  onClick={() => onRowClick && onRowClick(row)}
                  className={`group transition-colors duration-150 border-b border-slate-100 ${
                    rowIdx % 2 === 0 ? 'bg-slate-50/40' : 'bg-white'
                  } ${onRowClick ? 'cursor-pointer hover:bg-slate-100/80' : 'hover:bg-slate-50'}
                    ${isInactive ? 'bg-slate-100/70 opacity-70' : ''}
                  `}
                >
                  {columns.map((col, colIdx) => (
                    <td
                      key={`td-${colIdx}`}
                      className={`px-4 py-3 whitespace-nowrap align-middle text-[13px] font-normal text-slate-600 ${col.className || ''}`}
                    >
                      {col.render ? col.render(row, rowIdx) : row[col.key]}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};




